import moment from "moment"
export function contractCompleteListConfig(getMoney, selectPersonClick) {
    return {
        menuType: "button",
        addBtn: false,
        menuWidth: 120,
        menuAlign: "center",
        card: true,
        menu: false,
        delBtn: false,
        editBtn: false,
        align: "center",
        searchMenuSpan: 8,
        columnBtn: false,
        searchBtn: true,
        index: true,
        indexLabel: "序号",
        refreshBtn: true,
        // showSummary: true,
        selection: true,
        selectionWidth: 45,
        searchShow: false,
        border:true,
        column: [{
            label: '项目名称',
            hide: true,
            display: false,
            search: true,
            prop: 'searchName',
            placeholder: '请输入项目名称/合同名称'
        },{
            label: '保理合同',
            searchPlaceholder: "请输入保理合同",
            placeholder: '请输入保理合同',
            slot: true,
            prop: "contractName",
            width: 200,
        }, {
            label: '审批状态',
            prop: 'auditStatusStr',
        }, {
            label: '项目名称',
            searchPlaceholder: "请输入项目名称",
            placeholder: '请输入项目名称',
            prop: "projectName",
            // overHidden: true,
            width: '230'
        }, {
            label: '审批状态',
            prop: 'auditStatus',
            span: 12,
            hide: true,
            search: true,
            type: "select",
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=project_build_state",
            props: {
              label: "dictValue",
              value: "dictKey"
            }
        }, {
            label: '合同金额',
            prop: 'factoringCredit',
            overHidden: true,
            width: '150',
            formatter: (row, value, label, column) => {
                return `${getMoney(value)}元`;
            }
        },
         {
            label: '所属部门',
            width: '150',
            prop: 'managerDeptName'
        }, {
            label: '申请时间',
            width: '150',
            prop: 'createTime',
            formatter: (row, value, label, column) => {
                return value?moment(value).format('YYYY-MM-DD'):''
            },
            overHidden: true
        },
        {
            label: '日期范围',
            prop: 'timePic',
            type:'daterange',
            searchSpan:12,
            searchRange:true,
            search:true,
            hide:true
          }, 
          {
            label: "客户名称",
            placeholder: "请输入客户名称",
            search: true,
            prop: "sellerCustName",
            width: "180",
            searchslot: true,
            overHidden: true
        }, 
        {
            label: '业务主办',
            prop: 'managerUserName',
            search: true,
            width:80,
            click: () => {
                selectPersonClick();
            }            
        }, 
        {
            label: '业务协办',
            width:80,
            prop: 'assistUserName'
        }]
    }
}

export function addContractCompleteConfig() {
    return {
        labelWidth: 130,
        emptyBtn: false,
        submitBtn: false,
        column: [
            {
                label: '项目名称',
                prop: "projectName",
                formslot: true,
                rules: [{
                    required: true,
                    message: "请选择项目",
                    trigger: "change"
                }]
            }, {
                label: '保理合同',
                prop: "contractName",
                formslot: true,
                rules: [{
                    required: true,
                    message: "请选择合同",
                    trigger: "change"
                }]
            }, {
                label: '合同金额',
                prop: "contractFactoringCredit",
                disabled: true,
            }, {
                label: '客户名称',
                prop: "sellerCustName",
                disabled: true,
            }, {
                label: '保理商',
                prop: "formAccountingEntityStr",
                disabled: true,
            }, {
                label: '所属部门',
                prop: "managerDeptName",
                disabled: true,
            }, {
                label: '业务主办',
                prop: "managerUserName",
                disabled: true,
            }, {
                label: '业务协办',
                prop: "assistUserName",
                disabled: true,
            }, {
                label: '申请事项',
                prop: "applyOption",
                span: 24,
                type: 'checkbox',
                dicData: [{
                    label: '1.保证金退还',
                    value: '0'
                }, {
                    label: '2.办理抵、质押手续',
                    value: '1'
                }, {
                    label: '3.其它',
                    value: '2'
                }]
            }, {
                label: '备注',
                prop: "remark",
                type: 'textarea',
                span: 24
            }
        ]
    }
}

// 结清合计
export function completeTotalConfig() {
    return {
        labelWidth: 130,
        emptyBtn: false,
        submitBtn: false,
        column: [{
            label: '剩余保理首付款',
            prop: "totalSurplusPrincipalStr",
            disabled: true,
            append: '元'
        }, {
            label: '剩余使用费',
            prop: "totalSurplusInterestStr",
            disabled: true,
            append: '元'
        }, {
            label: '剩余超期费用',
            prop: "surplusOverdueAmountStr",
            disabled: true,
            append: '元'
        }, {
            label: '剩余退还保证金',
            prop: "totalSurplusRefundAmountStr",
            disabled: true,
            append: '元',
        }, {
            label: '其他费用',
            prop: "otherAmount",
            formslot:true,
            append: '元'
        }, {
            label: '说明',
            type: 'textarea',
            prop: "finishExplain",
            span: 24
        }],
    }
}

// 宽限期使用费及罚息信息
export function marginInfoConfig() {
    return {
        labelWidth: 130,
        emptyBtn: false,
        submitBtn: false,
        column: [{
            label: "保证金金额",
            prop: "name",
            disabled: true,
        }, {
            label: '到期处理方式',
            prop: "projectName",
            disabled: true,
        }
        ]
    }
}

// 宽限期使用费及罚息信息
export function completePymentConfig(changeReduce) {
    return {
        labelWidth: 130,
        emptyBtn: false,
        submitBtn: false,
        column: [{
            label: "总宽限期使用费",
            prop: "totalExpireAmountStr",
            disabled: true,
            append: '元'
        }, {
            label: '总罚息金额',
            prop: "totalOverdueInterestAmountStr",
            disabled: true,
            append: '元'
        }, {
            label: '总超期金额',
            prop: "totalOverdueAmountStr",
            disabled: true,
            append: '元'
        }, {
            label: '剩余总超期金额',
            prop: "totalSurplusOverdueAmountStr",
            placeholder: '填写减免金额后显示',
            disabled: true,
            append: '元',

        }, {
            label: '减免金额',
            prop: "creditAmount",
            formslot: true,
            append: '元',
            // change: ({ value, column }) => {
            //     changeReduce(value, column)
            //     return value
            // }
        }, {
            label: '说明',
            prop: "penaltyInterestExplain",
            type: 'textarea',
            span: 24,
        }
        ]
    }
}

// 详情页配置
export function detailFormOneConfig() {
    return [
        {
            label: '项目名称',
            prop: 'projectName',
            span: 12,
        }, {
            label: '保理合同',
            prop: 'contractName',
            span: 12,
        }, {
            label: '合同金额',
            prop: 'contractFactoringCredit',
            span: 12,
            unit: '元'
        }, {
            label: '客户名称',
            prop: 'sellerCustName',
            span: 12,
        }, {
            label: '保理商',
            prop: 'formAccountingEntityStr',
            span: 12,
        }, {
            label: '所属部门',
            prop: 'managerDeptName',
            span: 12,
        }, {
            label: '业务主办',
            prop: 'managerUserName',
            span: 12,
        }, {
            label: '业务协办',
            prop: 'assistUserName',
            span: 12,
        }, {
            label: '申请事项',
            prop: 'applyOption',
            span: 24,
            slot: true
        }, {
            label: '备注',
            prop: 'remarks',
            // type: 'textarea',
            disabled: true,
            span: 24
        }
    ]
}

export function detailFormTwoConfig() {
    return [
        {
            label: '总宽限期使用费',
            span: '8',
            prop: 'totalExpireAmountStr',
            unit: '元'
        }, {
            label: '总罚息金额',
            span: '8',
            prop: 'totalOverdueInterestAmountStr',
            unit: '元'
        }, {
            label: '总超期金额',
            span: '8',
            prop: 'totalOverdueAmountStr',
            unit: '元'
        }, {
            label: '剩余总超期金额',
            span: '8',
            prop: 'totalSurplusOverdueAmountStr',
            unit: '元'
        }, {
            label: '减免金额',
            span: '8',
            prop: 'creditAmountStr',
            unit: '元'
        }, {
            label: '说明',
            prop: 'penaltyInterestExplain',
            span: '24',
            // slot: true,
            // type: 'textarea'
        }
    ]
}

// 合同结清
export function detailFormThreeConfig() {
    return [
        {
            label: '剩余保理首付款',
            span: '12',
            prop: 'totalSurplusPrincipalStr',
            unit: '元'
        }, {
            label: '剩余使用费',
            span: '12',
            prop: 'totalSurplusInterestStr',
            unit: '元'
        }, {
            label: '剩余超期费用',
            span: '12',
            prop: 'surplusOverdueAmountStr',
            unit: '元'
        }, {
            label: '剩余退还保证金',
            span: '12',
            prop: 'totalSurplusRefundAmountStr',
            unit: '元'
        }, {
            label: '其他费用',
            span: '12',
            prop: 'otherAmount',
            unit: '元'
        }, {
            label: '备注',
            prop: 'finishExplain',
            span: '24',
        }
    ]
}